<template>
  <v-app>
    <v-main>
      <div class="content-wrapper">
        <!-- Content Header -->
        <div class="content-header">
          <div
            class="d-flex align-items-center"
            style="border-bottom: 1px solid #5c4a4a17; margin: auto !important"
          >
            <div class="row">
              <div class="col-12 d-flex flex-column align-items-baseline">
                <h1 class="m-0 text-dark">Clusters Management</h1>
                <ol class="breadcrumb float-sm-left">
                  <router-link
                    tag="li"
                    class="breadcrumb-item"
                    :to="{ name: 'Home' }"
                    >Home</router-link
                  >
                  <router-link
                    tag="li"
                    class="breadcrumb-item"
                    :to="{ name: 'Dashboard' }"
                    >Dashboard</router-link
                  >
                  <li class="breadcrumb-item active">Clusters Management</li>
                </ol>
                <div
                  class="position-absolute d-flex align-items-center h-100"
                  style="top: 0px; right: 11px; max-height: 200px;"
                >
                  <v-btn
                    class="width-fit-content mr-3"
                    style="height: 34px !important;"
                    @click="
                      entity = 'cluster';
                      shwCreateCluster = true;
                    "
                    color="primary"
                    elevation="2"
                    x-small
                    >Create Cluster</v-btn
                  >
                </div>
                <!-- <div
                  class="position-absolute d-flex align-items-center h-100"
                  style="top: 0px; right: 11px; max-height: 200px;"
                >
                  <v-btn
                    class="width-fit-content"
                    style="height: 34px !important;"
                    @click="
                      entity = 'db sub';
                      dialog = true;
                    "
                    color="primary"
                    elevation="2"
                    x-small
                    >Create Subs DataBase</v-btn
                  >
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- Main Content -->
        <div class="row p-3">
          <!-- Search -->
          <!-- <div class="w-100">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                class="mb-3"
                style="width: 50%"
              ></v-text-field>
            </div> -->
          <div class="col-12">
            <!-- Table -->
            <v-data-table
              :headers="headers"
              :items="clusters"
              :search="search"
              :loading="!clusters.length || false"
              :expanded.sync="expanded"
              single-expand
              show-expand
              dense
              item-key="id"
              loading-text="Loading ..."
              class="elevation-1"
            >
              <template v-slot:[`item.uid`]="{ item }">
                <span
                  class="cursor-pointer"
                  @click="
                    copyBtnId ? (copyBtnId = null) : (copyBtnId = item.id)
                  "
                >
                  {{ item.cluster_uid }}
                </span>
                <transition
                  enter-active-class="animate__animated animate__fadeIn animate__faster"
                  leave-active-class="animate__animated  animate__fadeOut animate__faster"
                >
                  <v-btn
                    v-show="copyBtnId === item.id"
                    class="btn-copy-cluster--l height-21 my-1"
                    color="primary"
                    elevation="2"
                    outlined
                    x-small
                    @click="
                      target = item.cluster_uid;
                      copyBtnId = null;
                      copyToClipboard('Cluster uid');
                    "
                    >Copy</v-btn
                  >
                </transition>
              </template>
              <template v-slot:[`item.id`]="{ item }">
                {{ item.id }}
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.cluster_name"
                  @save="editCluster(item.id, item)"
                  @cancel="cancelEditDialog"
                >
                  {{ item.cluster_name }}
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.cluster_name"
                      counter
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>
              <template v-slot:[`item.is_active`]="{ item }">
                <v-switch
                  v-model="item.is_active"
                  @change="
                    questionConfirmBtnText = 'Change';
                    questionType = 'activeness';
                    target = item;
                    targetType = 'cluster';
                    shwQuestion = true;
                  "
                ></v-switch>
              </template>
              <template v-slot:[`item.create_db_sub`]="{ item }">
                <v-btn
                  class="width-fit-content"
                  style="height: 34px !important;"
                  @click="
                    entity = 'db_sub';
                    db_sub[0].cluster_id = item.id;
                    shwCreateDbSub = true;
                  "
                  color="primary"
                  elevation="2"
                  x-small
                  >Create Subs DataBase</v-btn
                >
                <!-- <v-icon @click="db_sub[0].cluster_id = item.id"
                  >mdi-trash-can-outline</v-icon
                > -->
              </template>
              <template v-slot:[`item.editing_dialog`]="{ item }">
                <v-btn
                  class="width-fit-content"
                  elevation="2"
                  x-small
                  style="height: 34px !important"
                  @click="invokeToEditClusterConfig(item)"
                >
                  Edit Cluster Config
                </v-btn>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  @click="
                    id = item.id;
                    questionType = 'delete';
                    questionConfirmBtnText = 'Delete';
                    target = item;
                    targetType = 'cluster';
                    target.id = item.id;
                    shwQuestion = true;
                  "
                  >mdi-trash-can-outline</v-icon
                >
              </template>
              <template v-slot:expanded-item="{ item }">
                <td class="pt-5 px-0 border-right text-center">
                  <h6 class="border-bottom pb-2">Id</h6>
                  <p
                    v-for="(db, i) in item.db_subs"
                    :key="i"
                    :class="{
                      'mt-4': i === 0,
                      'height-21': !db.id,
                    }"
                  >
                    {{ db.id }}
                  </p>
                </td>
                <td colspan="2" class="pt-1 px-0 border-right text-center">
                  <h6 class="border-bottom pb-2">Name</h6>
                  <v-edit-dialog
                    v-for="(db_sub, i) in item.db_subs"
                    :key="i"
                    :return-value.sync="db_sub.name"
                    @save="editDbsub(db_sub.id, db_sub)"
                    @cancel="cancelEditDialog"
                    class="mt-4"
                  >
                    {{ db_sub.name }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="db_sub.name"
                        single-line
                        counter
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td colspan="2" class="pt-5 px-0 border-right text-center">
                  <h6 class="border-bottom pb-2">Region</h6>
                  <p
                    v-for="(db, i) in item.db_subs"
                    :key="i"
                    :class="{
                      'mt-4': i === 0,
                      'height-21': !db.region,
                    }"
                  >
                    {{ db.region }}
                  </p>
                </td>
                <td class="pt-5 px-0 border-right text-center">
                  <h6 class="border-bottom pb-2">Activeness</h6>
                  <p
                    v-for="(db, i) in item.db_subs"
                    :key="i"
                    :class="{
                      'mt-4': i === 0,
                    }"
                  >
                    {{ db.is_active }}
                  </p>
                </td>
                <td
                  class="pt-5 px-0 border-right text-center cluster-btn--col height-100"
                >
                  <span class="height-34"></span>
                  <v-btn
                    v-for="(db_sub, i) in item.db_subs"
                    :key="i"
                    class="width-fit-content height-21 font-size-8 mb-6"
                    elevation="2"
                    x-small
                    dense
                    @click="invokeToEditDbsubConfig(db_sub)"
                  >
                    Edit DataBase Config
                  </v-btn>
                </td>
                <td class="pt-7" style="width: 60px">
                  <v-icon
                    v-for="(db_sub, i) in item.db_subs"
                    :key="i"
                    class="my-3"
                    @click="
                      id = db_sub.id;
                      questionType = 'delete';
                      target = db_sub;
                      targetType = 'db';
                      questionConfirmBtnText = 'Delete';
                      shwQuestion = true;
                    "
                    >mdi-trash-can-outline</v-icon
                  >
                </td>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>

      <!-- Question Pop Up -->
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <Question
          v-if="shwQuestion"
          @didClose="shwQuestion = false"
          @confirmed="confirm"
          title="Are you sure?"
          :text="questionText"
          :confirmButtonText="questionConfirmBtnText"
          cancelButtonText="Cancel"
          confirmButtonClasses="btn btn-success"
          cancelButtonClasses="btn btn-danger"
          successIcon="success"
          errorIcon="error"
        />
      </transition>

      <!-- Success Snackbar -->
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <SuccessSnackbar
          v-if="success"
          :message="successText"
          @update-success="handleUpdateToSuccessSnackbar"
        />
      </transition>

      <!-- Failure Snackbar -->
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <FailureSnackbar
          v-if="failure"
          :message="failureText"
          @update-failure="handleUpdateToFailureSnackbar"
        />
      </transition>

      <!-- Dialog For Editing Config -->
      <v-dialog v-model="shwDialogToEditConfig" persistent width="350px">
        <v-card style="margin: 0 !important">
          <v-card-title class="justify-content-between">
            <span class="text-h5"
              >{{
                targetType && targetType === "cluster" ? "CLUSTER" : "DATABASE"
              }}
              CONFIG</span
            >
            <i
              class="bi-clipboard cursor-pointer"
              @click="copyToClipboard(targetType + ' config')"
            ></i>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="center" dense>
                <!-- Username & Password Cols -->
                <v-col cols="12">
                  <v-text-field
                    label="Username*"
                    v-model="target.username"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Password*"
                    type="password"
                    v-model="target.password"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Divider -->
                <div class="px-0">
                  <v-divider light></v-divider>
                </div>

                <!-- Driver & Port Cols -->
                <v-col cols="6">
                  <v-text-field
                    label="Driver*"
                    v-model="target.driver"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Port*"
                    v-model="target.port"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Divider -->
                <div class="px-0">
                  <v-divider light></v-divider>
                </div>

                <!-- Host & Database Cols -->
                <v-col cols="12">
                  <v-text-field
                    label="Host*"
                    v-model="target.host"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Database*"
                    v-model="target.database"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-2"
              text
              :disabled="processLoading"
              @click="shwDialogToEditConfig = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-2"
              text
              :loading="processLoading"
              @click="editConfig"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog To Create Database -->
      <v-dialog v-model="shwCreateDbSub" persistent width="350px">
        <v-card style="margin: 0 !important">
          <v-card-title class="justify-content-center">
            <span class="text-h5">
              CREATE DATABASE
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="center" dense>
                <v-col cols="12">
                  <v-text-field
                    label="Database name*"
                    v-model="db_sub[0].name"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>

                <v-col col="4">
                  <v-text-field
                    label="Region*"
                    v-model="db_sub[0].region"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col col="4">
                  <v-text-field
                    label="Shard Number*"
                    v-model="db_sub[0].shard_number"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col col="4">
                  <v-text-field
                    label="Activeness*"
                    v-model="db_sub[0].is_active"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>

                <div class="px-0">
                  <h2>Config</h2>
                  <v-divider light></v-divider>
                </div>

                <!-- Username & Password & Database cols -->
                <v-col cols="12">
                  <v-text-field
                    label="Username*"
                    v-model="db_sub[0].config.username"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Password*"
                    v-model="db_sub[0].config.password"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Database*"
                    v-model="db_sub[0].config.database"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Port & Driver & Host Cols -->
                <v-col col="2">
                  <v-text-field
                    label="Port*"
                    v-model="db_sub[0].config.port"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col col="4">
                  <v-text-field
                    label="Driver*"
                    v-model="db_sub[0].config.driver"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col col="6">
                  <v-text-field
                    label="Host*"
                    v-model="db_sub[0].config.host"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-2"
              text
              :disabled="processLoading"
              @click="shwCreateDbSub = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-2"
              text
              :loading="processLoading"
              @click="create(target)"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog To Create Cluster -->
      <v-dialog v-model="shwCreateCluster" persistent width="350px">
        <v-card style="margin: 0 !important">
          <v-card-title class="justify-content-center">
            <span class="text-h6">
              CREATE CLUSTER
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="center" dense>
                <!-- Cluster Name Col -->
                <v-col col="12">
                  <v-text-field
                    label="Cluster name*"
                    v-model="cluster[0].cluster_name"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Divider -->
                <div class="px-0">
                  <h5>
                    Cluster Config
                  </h5>
                  <v-divider light></v-divider>
                </div>

                <!-- Driver Col -->
                <v-col col="12">
                  <v-text-field
                    label="Driver*"
                    v-model="cluster[0].db_entities_master.driver"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Host Col -->
                <v-col col="12">
                  <v-text-field
                    label="Host*"
                    v-model="cluster[0].db_entities_master.host"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Divider -->
                <div class="px-0">
                  <v-divider light></v-divider>
                </div>

                <!-- Default Col -->
                <v-col cols="12">
                  <v-text-field
                    label="Default*"
                    v-model="cluster[0].default"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Subs Database & Clients Cols -->
                <v-col col="6">
                  <v-select
                    label="Subs Database*"
                    v-model="cluster[0].db_subs"
                    :items="db_subs"
                    item-text="name"
                    item-value="id"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-select>
                </v-col>
                <v-col col="6">
                  <v-select
                    label="Clients*"
                    v-model="cluster[0].clients"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-2"
              text
              :disabled="processLoading"
              @click="shwCreateCluster = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-2"
              text
              :loading="processLoading"
              @click="create()"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Error Pop Up -->
      <Error
        v-if="errorClient || errorDbsub || errorCluster"
        :error="errorClient || errorDbsub || errorCluster"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogWindow from "../popUps/DialogWindow.vue";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Question from "../popUps/Question.vue";
import Error from "../popUps/Error.vue";
import common from "../../mixins/common";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "Clusters",
  components: {
    DialogWindow,
    SuccessSnackbar,
    FailureSnackbar,
    Question,
    Error,
  },
  mixins: [common],
  data() {
    return {
      copyBtnId: null,
      failureText: "",
      successText: "",

      questionType: "",
      questionText: "",
      questionConfirmBtnText: "",

      target: "",
      targetType: "",

      success: false,
      failure: false,
      dialog: false,
      shwCreateDbSub: false,
      shwCreateCluster: false,
      shwQuestion: false,
      shwDialogToEditConfig: false,

      id: null,
      entity: "",

      expanded: [],
      headers: [
        {
          text: "Cluster UId",
          value: "uid",
          align: "start",
          sortable: false,
          divider: true,
          class: "table-header--color border-left",
          cellClass: "border-left"
        },
        {
          text: "Cluster Id",
          value: "id",
          align: "start",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Cluster Name",
          value: "name",
          align: "start",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Activeness",
          value: "is_active",
          align: "start",
          sortable: false,
          cellClass: "height-60",
          divider: true,
          class: "table-header--color d-flex align-items-center justify-content-center",
        },
        {
          text: "Create DB",
          value: "create_db_sub",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Edit Config",
          value: "editing_dialog",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          value: "actions",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
      ],

      cluster: [
        {
          cluster_name: "",
          db_entities_master: {
            driver: "",
            host: "",
          },
          default: null,
          db_subs: [],
          clients: [],
        },
      ],

      db_sub: [
        {
          cluster_id: null,
          name: "",
          region: "",
          shard_number: null,
          config: {
            driver: "",
            host: "",
            database: "",
            port: "",
            username: "",
            password: "",
          },
          is_active: null,
        },
      ],

      rules: {
        required: (value) => !!value || "Required.",
        clusterDefaultType: (value) =>
          value == 0 || value == 1 || "Value must be either 0 or 1.",
      },

      loading: false,
      processLoading: false,

      search: "",
    };
  },
  computed: {
    ...mapState({
      clusters: (state) => state.clusters.clusters,
      clients: (state) => state.clients.clients,
      db_subs: (state) => state.dbsubs.dbsubs[0],
      errorCluster: (state) => state.clusters.clusterError,
      errorDbsub: (state) => state.clusters.dbsubsError,
      errorClient: (state) => state.clusters.clientError,
    }),
    ...mapGetters(["getClients"]),
  },
  mounted() {
    this.getAllClusters();
    this.getAllClients();
    this.getAllDbsubs();
  },
  methods: {
    ...mapActions([
      "getAllClients",
      "getAllDbsubs",
      "getAllClusters",
      "createCluster",
      "updateCluster",
      "removeCluster",
      "createDbsub",
      "updateDbsub",
      "removeDbsub",
    ]),

    copyToClipboard(type) {
      if (undefined === this.target) {
        this.failureText = "Fail to copy 'undefined'!";
        this.failure = true;

        return false;
      }

      this.writeTextToClipboard(this.target).then(() => {
        this.successText = `${type} has been copied to clipboard successfully!`;
        this.success = true;
      });
    },

    runLoading() {
      this.processLoading = true;
      document.body.style.cursor = "wait";

      setTimeout(() => {
        this.processLoading = false;
        document.body.style.cursor = "default";
      }, 1000);
    },

    cancelEditDialog() {
      this.failureText = "Editing has been canceled";
      this.failure = true;
    },

    invokeToEditClusterConfig(obj) {
      setTimeout(() => {
        this.shwDialogToEditConfig = true;
      }, 1000);

      this.targetType = "cluster";
      this.target = Object.assign({ id: obj.id }, obj.db_entities_master);
    },

    invokeToEditDbsubConfig(obj) {
      setTimeout(() => {
        this.shwDialogToEditConfig = true;
      }, 1000);

      this.targetType = "db_sub";
      this.target = obj.config;
      this.target.id = obj.id;
    },

    checkRequiredFields(obj) {
      for (const [key, value] of Object.entries(obj)) {
        if (!value) {
          this.failure = true;
          this.failureText = "Fill the required fields out!";

          return false;
        }
      }

      return true;
    },

    editConfig() {
      let objForUpdating = new Object();

      setTimeout(() => {
        this.shwDialogToEditConfig = false;
      }, 1500);

      if (this.checkRequiredFields(this.target)) {
        this.runLoading();

        if (this.targetType === "cluster") {
          objForUpdating.id = this.target.id;
          delete this.target.id;
          objForUpdating.db_entities_master = this.target;

          this.updateCluster({
            id: objForUpdating.id,
            obj: objForUpdating,
          }).then(() => {
            this.successText = `Cluster 'db entities master' has been successfully updated!`;
            this.success = true;
          });
        } else if (this.targetType === "db_sub") {
          objForUpdating.cluster_id = this.target.cluster_id;
          delete this.target.cluster_id;
          objForUpdating.config = this.target;

          this.updateDbsub({
            id: objForUpdating.id,
            obj: objForUpdating,
          }).then(() => {
            this.successText = `Database config has been successfully updated!`;
            this.success = true;
          });
        }
      }
    },

    confirm() {
      setTimeout(() => {
        this.shwQuestion = false;
      }, 1000);

      if (this.questionType === "activeness") {
        if (this.targetType === "cluster") {
          this.editCluster(this.target.id, this.target);
        } else if (this.targetType === "db") {
          this.editDbsub(this.target.id, this.target);
        }
      } else if (this.questionType === "delete") {
        this.remove(this.target.id, this.targetType);
      }
    },

    editCluster(id, obj) {
      this.runLoading();

      this.updateCluster({ id, obj }).then(() => {
        this.successText = "Cluster has been successfully updated!";
        this.success = true;
      });
    },

    editDbsub(id, obj) {
      this.runLoading();

      this.updateDbsub({ id, obj }).then(() => {
        this.successText = "Permission has been successfully updated!";
        this.success = true;
      });
    },

    remove(id, entity) {
      this.runLoading();

      if (entity === "cluster") {
        this.removeCluster(id).then(() => {
          this.successText = "Cluster has been successfully deleted";
          this.success = true;
        });
      } else if (entity === "db_sub") {
        this.removeDbsub(id).then(() => {
          this.successText = "Db sub has been successfully deleted";
          this.success = true;
        });
      }

      this.getAllClusters();
    },

    create(event) {
      this.runLoading();

      //if (event) {
      if (this.entity === "cluster") {
        //this.cluster[0].cluster_name = event;
        let subs = this.cluster[0].db_subs;

        this.cluster[0].db_subs = new Array();
        this.cluster[0].db_subs.push(subs);

        if (
          this.cluster[0].cluster_name &&
          this.cluster[0].db_entities_master.driver &&
          this.cluster[0].db_entities_master.host &&
          this.cluster[0].default &&
          this.cluster[0].db_subs.length &&
          this.cluster[0].clients
        ) {
          this.createCluster(this.cluster[0])
            .then(() => {
              this.successText =
                this.entity + " has been successfully created!";
              this.success = true;

              setTimeout(() => {
                this.cluster[0].cluster_name = "";
                this.cluster[0].db_entities_master.driver = "";
                this.cluster[0].db_entities_master.host = "";
                this.cluster[0].default = null;
                this.cluster[0].clients = [];
                this.cluster[0].db_subs = [];

                this.dialog = false;
              }, 1000);
            })
            .catch((error) => {
              this.error = error;
            });
        } else {
          this.failureText = "Fill out the " + this.entity + " required fields!";
          this.failure = true;
          this.processLoading = false;
        }
      } else if (this.entity === "db_sub") {
        this.db_sub[0].name = event;

        this.createDbsub(this.db_sub[0])
          .then((response) => {
            this.successText = this.entity + " has been successfully created!";
            this.success = true;

            this.getAllClusters();

            setTimeout(() => {
              this.db_sub[0].cluster_id = null;
              this.db_sub[0].name = "";
              this.db_sub[0].region = "";
              this.db_sub[0].shard_number = null;
              this.db_sub[0].config = {
                driver: "",
                host: "",
                database: "",
                port: "",
                username: "",
                password: "",
              };
              this.db_sub[0].is_active = null;

              this.dialog = false;
            }, 1000);
          })
          .catch((error) => {
            this.error = error;
          });
      }
      // } else {
      //   this.failure = "Fill out the " + this.entity + " required fields!";
      //   this.failure = true;
      //   this.processLoading = false;
      // }
    },
  },
};
</script>

<style>
.no-border-bottom > .v-input__control > .v-input__slot:after,
.no-border-bottom > .v-input__control > .v-input__slot:before {
  width: 0 !important;
}
</style>
